
import app from '../index';

export default class RechnungNeuController {

  constructor($routeParams, $scope) {
    this.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    this.vorlageId = $routeParams.vorlageId;

    $scope.$watch("vm.neueRechnung.kunde", (newValue, oldValue) => {
      if (oldValue === newValue) {
        return;
      }

      if (!newValue) {
        this.neueRechnung.anschrift = null;
        this.neueRechnung.lieferanschrift = null;
      } else {
        this.neueRechnung.anschrift = newValue.anschrift;
        if (newValue.lieferanschrift) {
          this.neueRechnung.lieferanschrift = this.neueRechnung.anschrift;
        } else {
          this.neueRechnung.lieferanschrift = newValue.lieferanschrift;
        }
      }
    });

    this.refresh();
  }

  refresh() {

    if (this.vorlageId) {

      this.neueRechnung = app.api.rechnungen.aendern({
        id: this.vorlageId
      }, (rechnung) => {

        // input requires a date
        rechnung.datum = new Date(rechnung.datum);

        if (rechnung.ihrDatum) {
          rechnung.ihrDatum = new Date(rechnung.ihrDatum);
        }

        for (var i = 0; i < rechnung.details.length; i++) {
          var detail = rechnung.details[i];

          if (!detail.artikel) {
            detail.artikel = detail.bezeichnung;
          }
        }

        this.newDetail();
      });
    } else {
      this.neueRechnung = {
        datum: new Date(),
        portoVerpackung: 0,
        nettoBetrag: 0,
        nettoWarenwert: 0,
        bruttoBetrag: 0,
        mehrwertsteuer: 19.0,
        versandart: "per Post ab Lager",
        details: []
      };
      this.newDetail();
    }
  }

  getKunden(name) {
    return app.api.kunden.query({
      name: name
    })
      .$promise
      .then((response) => {
        return response;
      });
  }

  getArtikel(name) {
    return app.api.artikel.query({
      bezeichnung: name
    })
      .$promise
      .then((response) => {
        return response;
      });
  }

  updateGesamtBetrag(details) {
    this.neueRechnung.nettoWarenwert = 0;
    for (var i = 0, n = details.length; i < n; i++) {
      this.neueRechnung.nettoWarenwert += details[i].betrag;
    }
  }

  updateBetrag(detail) {
    if (!detail.preis) {
      detail.preis = 0;
    }

    if (!detail.menge) {
      detail.menge = 0;
    }

    detail.betrag = detail.menge * detail.preis;
    this.updateGesamtBetrag(this.neueRechnung.details);
  }

  detectNewLine(detail) {
    if (detail.isNewLine) {
      detail.isNewLine = false;
      this.newDetail(detail);
    }
  }

  newDetail(detail) {
    var einheit = "Stck.";
    var menge = 0;
    var preis = 0;

    if (detail) {
      einheit = detail.einheit;
      menge = detail.menge;
      preis = detail.preis;
    }

    var newDetail = {
      isNewLine: true,
      menge: menge,
      einheit: einheit,
      artikel: null,
      preis: preis,
      betrag: 0
    };

    this.neueRechnung.details.push(newDetail);
    this.updateBetrag(newDetail);
  }

  removeDetail(index) {
    this.neueRechnung.details.splice(index, 1);
  }

  updateArtikel(detail) {
    if (detail.artikel && detail.artikel.bezeichnung) {
      detail.bezeichnung = detail.artikel.bezeichnung;
    } else {
      detail.bezeichnung = detail.artikel;
    }
  }

  save() {
    this.neueRechnung.details.forEach((detail) => {
      if (detail.artikel && !detail.artikel.id) {
        detail.artikel = null;
      }
    });

    if (this.neueRechnung.kunde && !this.neueRechnung.kunde.id) {
      this.neueRechnung.kunde = {
        id: null,
        name: this.neueRechnung.kunde,
        anschrift: this.neueRechnung.anschrift,
        lieferanschrift: this.neueRechnung.lieferanschrift
      };
    }

    this.saving = true;
    app.api.rechnungen.save(this.neueRechnung, (success) => {
      this.saving = false;
      app.$location.path("rechnungen/" + success.id);
    });
  }
}

RechnungNeuController.$inject = ['$routeParams', '$scope'];



// WEBPACK FOOTER //
// ./app/rechnungen/rechnungNeuController.js